<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title> Dados do registro </v-card-title>
      <v-card-text>
        <v-form>
            <v-row>
          <div class="col-3">
            <v-text-field
              label="Nome"
              v-model="current.name"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-9">
            <v-text-field
              label="Descrição"
              v-model="current.description"
              outlined
              dense
            ></v-text-field>
          </div>
            </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: function () {
    return {
      current: null,
    };
  },
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contact_type/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function (error) {
          console.log(error);
          alert("Falha ao recuperar registro!");
        });
    },
    save: function () {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/contact_type", this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Cadastrado com sucesso!");
            router.push({ path: "/contact_type" });
          })
          .catch(function (error) {
            console.log(error);
            alert("Falha ao cadastrar registro!");
          });
      } else {
        api
          .put("/contact_type/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Atualizado com sucesso!");
            router.push({ path: "/contact_type" });
          })
          .catch(function (error) {
            console.log(error);
            alert("Falha ao atualizar registro!");
          });
      }
    },
  },
};
</script>